/**
 * Connecticut 2022+ planning regions (FIPS 091xx) replaced legacy counties in the choropleth.
 * CDC CSV has full history on legacy county rows; 2023 counts on planning-region rows only.
 * For years before 2023, approximate each region's count from statewide legacy totals using
 * that region's share of 2023 planning-region reporting.
 */
import { getCaseCount } from './parseLymeCsv.js';

export const CT_LEGACY_COUNTY_FIPS = [
    '09001',
    '09003',
    '09005',
    '09007',
    '09009',
    '09011',
    '09013',
    '09015',
];

export const CT_PLANNING_REGION_FIPS = [
    '09110',
    '09120',
    '09130',
    '09140',
    '09150',
    '09160',
    '09170',
    '09180',
    '09190',
];

function isCtPlanningRegion(fips) {
    return CT_PLANNING_REGION_FIPS.includes(fips);
}

/**
 * Case count for a map feature: normal counties use CSV rows; CT planning regions use 2023
 * row or proportional allocation for earlier years.
 */
export function getCaseCountForMap(rowsByFips, fips, year) {
    if (!fips) return 0;
    const y = Number(year);
    if (isCtPlanningRegion(fips)) {
        const row = rowsByFips.get(fips);
        if (!row) return 0;
        if (y === 2023) {
            return getCaseCount(row, 2023);
        }
        const legacyTotal = CT_LEGACY_COUNTY_FIPS.reduce(
            (sum, cf) => sum + getCaseCount(rowsByFips.get(cf), y),
            0,
        );
        const denom2023 = CT_PLANNING_REGION_FIPS.reduce(
            (sum, rf) => sum + getCaseCount(rowsByFips.get(rf), 2023),
            0,
        );
        if (denom2023 <= 0) return 0;
        const region2023 = getCaseCount(row, 2023);
        return Math.round(legacyTotal * (region2023 / denom2023));
    }
    if (rowsByFips.has(fips)) {
        return getCaseCount(rowsByFips.get(fips), year);
    }
    return 0;
}
